import {getSubmit, postSubmit} from "ui-seeker/utils";
import {ALERTS, OVERVIEW} from "app/@common/constants";
import {useContextSelector} from "use-context-selector";
import {AppCalendarContext, AppCalendarEventsContext} from "../../Providers";
import {useEffect} from "react";


export default function useAppCalendar(dateRange, startDate, externalEvents) {

    const updateCalendar = useContextSelector(AppCalendarContext, ({ updateState }) => updateState)
    const isLoading = useContextSelector(AppCalendarContext, ({ state }) => state.isLoading)
    const updateEvents = useContextSelector(AppCalendarEventsContext, ({ updateState }) => updateState)
    const eventsData = useContextSelector(AppCalendarEventsContext, ({ state }) => state.eventsData)

    const month = dateRange === 'custom' ? startDate?.slice(4, 6) : dateRange?.slice(4, 6)
    const year = dateRange === 'custom' ? startDate?.slice(0, 4) : dateRange?.slice(0, 4)

    useEffect(() => {
        updateEvents({ eventsData: [...eventsData, ...externalEvents] })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(externalEvents)]);

    useEffect(() => {
        Promise.all([
            getSubmit(`${OVERVIEW.EVENTS}/${month}/${year}`, {}),
            getSubmit(`/api/user-config/percentage-color/get`, {}),
            postSubmit(`${ALERTS.MONTH_LIST}/${month}/${year}`, {
                tp: [ALERTS.COMPETITION_NA, ALERTS.COMPETITION, ALERTS.INFO]
            })
        ]).then(([eventsData, percentageData, monthAlerts]) => {
            const sliderColor = percentageData ? [percentageData.percentage_low, percentageData.percentage_high] : [];
            updateCalendar({
                sliderColor,
                isLoading: false,
            });
            updateEvents({
                monthAlerts: monthAlerts || {},
                eventsData,
            })
        });
    },[month, updateCalendar, updateEvents, year])

    return {
        isLoading,
        month,
        year,
    }
}